module.exports = __webpack_public_path__ + "static/img/analyzer3.48db268a.png";